import { useQuery, gql } from '@apollo/client';

export const GET_REVIEWER_STATS = gql`
  query GetReviewerStats(
    $repositoryIds: [ID!],
    $startDate: ISO8601DateTime,
    $endDate: ISO8601DateTime,
    $groupBy: ReviewerStatsGroupByEnum
  ) {
    reviewerStats(
      filterBy:{
        repositoryId: { in: $repositoryIds },
        submittedAt: { gte: $startDate, lte: $endDate }
      },
      groupBy: $groupBy
    ) {
      nodes {
        reviewer {
          type
          name
          avatarUrl
        }
        totalReviews
        totalComments
        medianTimeToReview
        averageComments
        totalAdditions
        totalDeletions
      }
    }
  }
`;

export const useReviewerStatsQuery = ({
  repositoryIds,
  startDate,
  endDate,
  groupBy,
}) => {
  const { data, loading, refetch } = useQuery(
    GET_REVIEWER_STATS,
    {
      variables: {
        repositoryIds,
        startDate,
        endDate,
        groupBy,
      },
    },
  );

  const reviewerStats = data?.reviewerStats?.nodes.map(({
    reviewer: { type, name, avatarUrl },
    totalReviews,
    totalComments,
    medianTimeToReview,
    averageComments,
    totalAdditions,
    totalDeletions,
  }) => ({
    user: name,
    userType: type,
    avatarUrl,
    totalReviews,
    totalComments,
    medianTimeToReview,
    averageComments,
    totalAdditions,
    totalDeletions,
  })) || [];

  return { reviewerStats, loading, refetch };
};
